import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectedProductSelector } from 'ctm-selectors';
import { Text, ProductAdditionalExcessListItem } from 'ctm-components';

class _ProductExcesses extends Component {

    /**
     * Creates a formatted amount string, prefixed by $
     * @param {string|number} amount - The amount to display, string/number
     * @returns {string} - The formatted amount string
     */
    formatAmount = (amount) => {
        if (!amount) return '';
        const stringAmount = amount.toString();
        return !stringAmount.includes('$') ? `$${stringAmount}` : stringAmount;
    };

    /**
     * Renders the ProductAdditionalExcessListItems
     * @returns {Array} - Array of ProductAdditionalExcessListItem's
     */
    renderAdditionalExcesses = () => {
        const { additionalExcesses } = this.props;
        return additionalExcesses && additionalExcesses.size > 0 ? additionalExcesses.map((excess) => {
            const label = excess.get('description');
            const amount = this.formatAmount(excess.get('amount'));
            return <ProductAdditionalExcessListItem key={label} label={label} amount={amount} />;
        }).toArray() : (<p>Refer to PDS</p>);
    };

    /**
     * Renders the ProductExcesses component
     * @returns {Node} Returns the ProductExcesses component
     */
    render = () => {
        const { excess, glassExcess } = this.props;
        const excessesHeading =  <Text label="Excesses" size="xlarge" color="brand_base_120" tagName="h5" />;
        const additionalExcessesHeading = <Text label="Additional Excesses" size="large" color="brand_base_120" tagName="h6" />;

        return (
            <>
                {excessesHeading}
                <ProductAdditionalExcessListItem key="basicExcess" label="Basic Excess" amount={this.formatAmount(excess)} />
                {glassExcess && <ProductAdditionalExcessListItem key="glassExcess" label="Glass Excess" amount={this.formatAmount(glassExcess)} />}
                {additionalExcessesHeading}
                {this.renderAdditionalExcesses()}
            </>
        );
    };

}

_ProductExcesses.propTypes = {
    excess: PropTypes.number,
    glassExcess: PropTypes.string,
    additionalExcesses: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string,
            amount: PropTypes.oneOf([PropTypes.string, PropTypes.number])
        })
    )
};

/**
 * Maps state to props
 * @param {Object} state state The redux state
 * @returns {Object} Mapped state to props
 */
const mapStateToProps = (state) => {
    const selectedProduct = selectedProductSelector(state);

    return {
        excess: selectedProduct.getIn(['productMeta', 'excess']),
        glassExcess: selectedProduct.getIn(['productMeta', 'glassExcess']),
        additionalExcesses: selectedProduct.getIn(['productMeta', 'additionalExcesses'])
    };
};

const ProductExcesses = connect(mapStateToProps)(_ProductExcesses);

export { _ProductExcesses, ProductExcesses };
